import React, { useContext } from 'react';
import { get } from 'lodash';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import {
  useEventCallback,
  NavigationContext,
  DashboardCardAction,
  DashboardCardProps,
} from '@eas/common-web';
import { EvidenceUrl } from '../../../enums';
import { CustomCardBase } from './custom-card-base';

export function CardOVZ({ report, definitionId }: DashboardCardProps) {
  const { navigate } = useContext(NavigationContext);

  const count = get(report, 'data[0].count');

  const navigateMain = useEventCallback(() => {
    navigate(EvidenceUrl.OVZ_FACILITIES);
  });

  const navigateNewRegistration = useEventCallback(() => {
    navigate(EvidenceUrl.OVZ_FACILITY_NEW);
  });

  return (
    <CustomCardBase
      title="Registr provozoven OVZ"
      definitionId={definitionId}
      value={count}
      icon={<CloudQueueIcon />}
      navigate={navigateMain}
    >
      <DashboardCardAction
        navigate={navigateNewRegistration}
        title="Nová registrace"
      />
    </CustomCardBase>
  );
}
